import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { ContractsEffects } from '@appStore/contracts/effects/contracts.effects';
import { BudgetsEffects } from '@appStore/contracts/effects/budgets.effects';
import { AgreementEffects } from '@appStore/contracts/effects/agreements.effects';
import { ServiceAgreementsEffects } from '@appStore/contracts/effects/service-agreements.effects';

export const effects = [ContractsEffects, BudgetsEffects, AgreementEffects, ServiceAgreementsEffects  ];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class ContractsEffectsModule {}
